import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';
import { rem } from '@utils/rem';

export const Container = styled.form`
  height: 100vh;
  max-height: 100vh;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  /* n50, like figma */
  background: #fafbfd;

  /* Auth0 mq */
  @media (max-width: 600px) {
    [data-device='${deviceTypes.mobile}'] & {
      align-items: flex-start;
      background: #fff;
    }
  }
`;

export const Body = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 26px rgba(0, 0, 0, 0.12);
  padding: 40px;
  padding-top: 74px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 437px;

  /* Auth0 mq */
  @media (max-width: 600px) {
    [data-device='${deviceTypes.mobile}'] & {
      padding-top: 40px;
      box-shadow: none;
    }
  }

  .Organization_logo {
    height: 52px;
  }
  .Organization_welcomeGroup {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  padding: 8px;

  :disabled {
    background-color: #edeff4;
    color: #c1c4d6;
  }
`;

export const Description = styled.div`
  width: 100%;
  text-align: center;
  color: #1e212a;
  font-size: ${rem(16)};

  &.warning {
    color: #ffab54;
    margin-top: ${rem(16)};
  }
  &.welcome {
    font-size: ${rem(20.25)};
    line-height: 1.5;
  }
  &.welcome-extra {
    font-size: ${rem(13.125)};
    line-height: 1.5;
  }
`;
export const ErrorContainer = styled.div`
  width: 100%;
  color: #f03;
  font-size: 12px;
  margin-left: 4px;
  margin-top: 4px;
`;

export const Continue = styled.div`
  color: #1371fe;
  font-size: 14px;
  width: 100%;
  text-align: center;
  cursor: pointer;
`;

interface IHelperText {
  isFocused?: boolean;
}

export const HelperText = styled.label<IHelperText>`
  display: flex;
  background-color: #fff;
  padding: 0px 6px;
  margin-bottom: -10px;
  margin-left: 16px;
  align-self: flex-start;
  color: ${({ isFocused }) => (isFocused ? '#1371fe' : '#65676e')};
  font-size: 14px;
  z-index: 200;

  transition: all 0.2s ease;
`;

export const Input = styled.input<IHelperText>`
  border-radius: 4px;
  height: 42px;
  color: #2d333a;
  padding: 8px 12px;
  border: 1px solid #c9cace;
  width: 100%;
  font-size: 14px;

  transition: all 0.4s ease;

  :focus-within {
    border: 1px solid #1371fe;
  }
`;
